import { render, staticRenderFns } from "./getSpacificTrancation.vue?vue&type=template&id=54c18476&scoped=true"
import script from "./getSpacificTrancation.vue?vue&type=script&lang=js"
export * from "./getSpacificTrancation.vue?vue&type=script&lang=js"
import style0 from "./getSpacificTrancation.vue?vue&type=style&index=0&id=54c18476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c18476",
  null
  
)

export default component.exports